import { render } from "./item_price_change_form.vue?vue&type=template&id=af6e8296&scoped=true"
import script from "./item_price_change_form.vue?vue&type=script&lang=js"
export * from "./item_price_change_form.vue?vue&type=script&lang=js"

import "./item_price_change_form.vue?vue&type=style&index=0&id=af6e8296&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af6e8296"]])

export default __exports__